import React, { useState } from 'react';
import logo from '../assets/logo.svg';

const Nav = () => {
  const [opened, setOpened] = useState(true);

  return (
    <div className='w-100'>
      <div className='container'>
        <header className='flex jcsb aic h-10 py-5'>
          <h1 id='logo'>
            <a href='/ua' aria-label='Логотип'>
              <img src={logo} width={128} height={48} alt='c4u' />
            </a>
          </h1>
          <div
            className={opened ? 'burger' : 'burger open'}
            onClick={() => setOpened(!opened)}
          >
            <span className='tt'></span>
            <span className='mm'></span>
            <span className='bb'></span>
          </div>
          <div className={opened ? 'menu active' : 'menu'}>
            <a
              href='#about'
              className='mx-3 px-1'
              onClick={() => setOpened(!opened)}
            >
              Про Курси
            </a>
            <a
              href='#offer'
              className='mx-3 px-1'
              onClick={() => setOpened(!opened)}
            >
              Програма
            </a>
            <a
              href='#cta'
              className='mx-3 px-1'
              onClick={() => setOpened(!opened)}
            >
              Обрати напрямок
            </a>
            <a
              href='#contact'
              className='mx-3 px-1'
              onClick={() => setOpened(!opened)}
            >
              Контакти
            </a>
            <a
              href='/'
              className='mx-3 px-1'
              onClick={() => setOpened(!opened)}
            >
              RU
            </a>
            <a
              href='/ua'
              className='mx-3 px-1 m-block'
              onClick={() => setOpened(!opened)}
            >
              Увійти
            </a>
          </div>
          <a href='/ua' className='button top m-hide'>
            Увійти
          </a>
        </header>
      </div>
    </div>
  );
};

export { Nav }; 